module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABC0lEQVQ4jc2PMUsCYRjHf6+cNHWDY94U+AFc1IjWrOFuEBICP0At0S5O9QlaamisxaDhbolbHBr0XBxyEwT1CjpC5MwhqK7h0Ax6OXSp3/S8z/P+fzwP/DUCwDTNYJmwYRhCmT50XV8obFkWAMp8c1wshc2NLADvdQeA1eqVVKQA7F+O2GrYXNcdVvYKxHMZAD4HLm83t+yWbe7bz3LBPEJV+XAfZ3UUscgfEcw26HsTYlqSWrWGs/YCQPbpgU0tSd+bRAt63iun+WPOW/73NJXmMK3Sa42lAgEw1FIBhDefbB9x0Q2HB+tQsc8IfP/XcMLtiB+CqaSZ2wEg07iThqWCRUi4HbFM7p/xBQx9UDUcsonSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SK.png
// module id = 1263
// module chunks = 0